import classNames from "classnames";
import SquareImageLeftTitle from "src/components/articledisplays/SquareImageLeftTitle";
import ButtonLink from "src/components/buttonlink/ButtonLink";
import RoundNewsPageWithBling from "src/components/svg/RoundNewsPageWithBling";
import styles from './SlimArticleBlock.module.css';
import { GroupedLayoutObject, ISlimArticleBlock } from "src/lib/types/IForsidenV2";

//#region [Props]
type SlimArticleBlockProps = {
    block: GroupedLayoutObject<ISlimArticleBlock>;
};
//#endregion

//#region [Component]
export default function SlimArticleBlock({ block }: SlimArticleBlockProps) {
    const hasLink = !!(block.linkUrl && block.linkTitle);
    const themeClass = block.themes ? (styles as Record<string, string>)[block.themes] : styles.dark;

    return <section>
        {block.label && <header className={styles.SListHeader}><h2>{block.label}</h2></header>}
        <div className={classNames(styles.SList, themeClass, { [styles.withSeparators]: block.showSeparators, [styles.withLink]: hasLink })}>
            <div className={classNames(styles.SItemContainer, { [styles.withSeparators]: block.showSeparators, [styles.withLink]: hasLink })}>
                {block.articles.filter(doc => !!doc).slice(0, 3).map(doc =>
                    <SquareImageLeftTitle key={doc._id}
                        className={styles.SSquareImageLeftTitle}
                        document={doc}
                        themeValue={block.themes}
                        showSeparator={block.showSeparators}
                        imageWidth={64}
                    />)}
            </div>
            {hasLink && <ButtonLink className={styles.SListLink} href={block.linkUrl}>
                <div className={styles.SRoundNewsPageWithBling}>
                    <RoundNewsPageWithBling className={styles.SIconSvg} />
                </div>
                {block.linkTitle}
            </ButtonLink>}
        </div>


    </section>;
}
//#endregion


//#endregion
